import type { MetaStructuredDataOutputType } from "@dotcom/remix-meta";
import { SupportedTypes } from "@dotcom/remix-meta";

import {
  type NewsArticleMetaInputType,
  type NewsArticleStructuredData,
} from "./NewsArticleMetaTypes";

const getNewsArticleMeta = ({
  headline,
  modifiedDate,
  publishDate,
  heroSection,
}: NewsArticleMetaInputType): MetaStructuredDataOutputType<NewsArticleStructuredData> => {
  if (!headline) return [];

  const newsArticleStructuredData: NewsArticleStructuredData = {
    "@context": "https://schema.org",
    "@type": SupportedTypes.NEWS_ARTICLE,
    headline,
  };

  if (publishDate) {
    newsArticleStructuredData.datePublished = new Date(
      publishDate
    ).toISOString();
  }

  if (modifiedDate) {
    newsArticleStructuredData.dateModified = modifiedDate;
  }

  // add images from hero section
  if (heroSection) {
    const images = [];
    if (heroSection.imageDesktop)
      images.push(`${heroSection.imageDesktop.url}?q=60&dpr=1&w=1248`);
    if (heroSection.imageTablet)
      images.push(`${heroSection.imageTablet.url}?q=60&dpr=1&w=959`);
    if (heroSection.imageMobile)
      images.push(`${heroSection.imageMobile.url}?q=60&dpr=1&w=767`);

    if (images.length > 0) newsArticleStructuredData.image = images;
  }

  return [
    {
      "script:ld+json": newsArticleStructuredData,
    },
  ];
};

export default getNewsArticleMeta;
